<script setup>
import {computed} from 'vue'
import {useFormStore} from '@/stores/form'

import FormDisplayOrderMenu from "@/common/form/FormDisplayOrderMenu"
import FormDuplicateBtn from "@/common/form/FormDuplicateBtn"
import FormDeleteBtn from "@/common/form/FormDeleteBtn"
import FormPublishBtn from "@/common/form/FormPublishBtn"
import FormArchiveBtn from "@/common/form/FormArchiveBtn.vue"

const props = defineProps({
    formId: String
})

const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

const currentData = computed(() => formStore.value?.currentData || {})
</script>

<template>
    <div>
        <FormPublishBtn :form-id="formId" class="mb-3"/>
        <FormDisplayOrderMenu v-if="currentData.id" :form-id="formId" class="mb-2"/>
        <FormDuplicateBtn :form-id="formId"/>
        <FormArchiveBtn :form-id="formId"/>
        <FormDeleteBtn :form-id="formId"/>
    </div>
</template>